var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.17,
    height: 31.17,
    viewBox: "0 0 31.17 31.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "txt",
    transform: "translate(-4062.361 -1913.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M4093.531,1922.857v17.39a4.421,4.421,0,0,1-4.42,4.42h-22.33a4.421,4.421,0,0,1-4.42-4.42v-22.33a4.422,4.422,0,0,1,4.42-4.42h17.39Z",
    fill: "#292733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M4084.171,1918.437v-4.94l9.36,9.36h-4.94A4.422,4.422,0,0,1,4084.171,1918.437Z",
    fill: "#47464c"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "TXT-2",
    "data-name": "TXT",
    transform: "translate(4077.032 1938.247)",
    fill: "#fff",
    fontSize: 14.627,
    fontFamily: "FjallaOne-Regular, Fjalla One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.538,
    y: 0
  }, "TXT")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.90c08e895258f4adf3dc7527a4858bb8.svg";
export { ForwardRef as ReactComponent };